import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const defaultTitleTag = 'index_meta_title';
const defaultDescriptionTag = 'index_meta_description';

function Head({
  titleTag = defaultTitleTag,
  descriptionTag = defaultDescriptionTag,
}) {
  const intl = useIntl();

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{intl.formatMessage({ id: titleTag })}</title>
      <link rel="canonical" href="https://artemacorp.com" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/manifest.webmanifest" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#000000" />
      <meta
        name="description"
        content={intl.formatMessage({ id: descriptionTag })}
      />
    </Helmet>
  );
}

export default Head;
